export default {
  tabs: {
    home: "Accueil",
    browse: "Explorer",
    trends: "Tendances",
    myPicks: "Mes choix",
    leagues: "Ligues",
  },
  common: {
    viewAll: "Tout voir",
    operator: "Opérateur",
    priceComparison: "Comparaison des cotes",
    linematePlus: "Linemate+",
    joinLinematePlus: "Rejoindre Linemate+",
    actions: {
      apply: "Appliquer",
      clearAll: "Tout effacer",
      gotIt: "Compris",
      cancel: "Annuler",
      close: "Fermer",
      openSettings: "Ouvrir les réglages",
      continue: "Continuer",
      claim: "Réclamer",
      visitPartner: "Visiter le partenaire",
      alreadyHaveAccount: "J'ai déjà un compte",
      edit: "Modifier",
      done: "Terminé",
      save: "Enregistrer",
      changePassword: "Changer le mot de passe",
      submit: "Envoyer",
      resendCode: "Renvoyer le code",
      getStarted: "Commencer",
      continueWithApple: "Continuer avec Apple",
      continueWithGoogle: "Continuer avec Google",
      continueWithEmail: "Continuer avec courriel",
      selectLocation: "Choisir un emplacement",
      showMore: "Afficher plus",
    },
    labels: {
      player: "Joueur",
      team: "Équipe",
      firstName: "Prénom",
      lastName: "Nom",
      username: "Nom d'utilisateur",
      email: "Courriel",
      password: "Mot de passe",
      emailAddress: "Adresse courriel",
      confirmPassword: "Confirmer le mot de passe",
      code: "Code",
      preferredOdds: "Cotes préférées",
    },
    placeholders: {
      emailAddress: "Entrez votre adresse courriel...",
      password: "Entrez votre mot de passe...",
    },
    errors: {
      genericTryAgainLater: "Une erreur est survenue. Veuillez réessayer plus tard.",
      noInternetConnection: "Aucune connexion Internet",
    },
    search: {
      teamOrPlayerPlaceholder: "Rechercher une équipe ou un joueur...",
    },
    affiliate: {
      claimYourOffer: "Réclamez votre offre {{operator}}",
    },
    advancedTools: {
      startingLineups: "Formations partantes",
      startingPitchers: "Lanceurs partants",
      weatherReport: "Météo",
    },
    toasts: {
      addedToMyPicks: "Ajouté à Mes choix",
      alreadyInMyPicks: "Déjà dans Mes choix",
    },
    hints: {
      goToMyPicks: "Allez à Mes choix pour placer votre pari.",
    },
    profile: {
      completeYourProfile: "Complétez votre profil",
    },
    bonuses: "Bonus",
    statHeaders: {
      "+/-": "+/-",
      "1B": "1B",
      "1D": "1D",
      "1PT": "1PT",
      "20/40": "20/40",
      "2B": "2B",
      "2PT": "2PT",
      "2YELRED": "2YELRED",
      "3B": "3B",
      "3D%": "3D%",
      "3PT%": "3PT%",
      "3PTA": "3PTA",
      "3PTM": "3PTM",
      "4D%": "4D%",
      "40/20": "40/20",
      "A": "A",
      "AB": "AB",
      "AST": "AST",
      "AVG": "AVG",
      "B": "B",
      "BB": "BB",
      "BK": "BK",
      "BLK": "BLK",
      "C%": "C%",
      "CA": "CA",
      "CF%": "CF%",
      "CFK": "CFK",
      "CM": "CM",
      "COR": "COR",
      "CR%": "CR%",
      "CS": "CS",
      "D": "D",
      "DHR": "DHR",
      "DP": "DP",
      "DR": "DR",
      "DRI": "DRI",
      "DSAV": "DSAV",
      "EFG%": "eFG%",
      "ER": "ER",
      "ERA": "ERA",
      "FG": "FG",
      "FG%": "FG%",
      "FGA": "FGA",
      "FGM": "FGM",
      "FLS": "FLS",
      "FT%": "FT%",
      "FTA": "FTA",
      "FTM": "FTM",
      "FUML": "FUML",
      "G": "B",
      "GA": "BC",
      "GK": "GK",
      "GP": "MJ",
      "OPP": "ADV",
      "H": "H",
      "HO": "HO",
      "HR": "HR",
      "HU": "HU",
      "INT": "INT",
      "ISO": "ISO",
      "IS": "IS",
      "K": "K",
      "KM": "KM",
      "KR": "KR",
      "KRM": "KRM",
      "L": "D",
      "LB": "LB",
      "LOP": "LOP",
      "M": "M",
      "MI50": "MI50",
      "MIN": "MIN",
      "OBP": "OBP",
      "OFF": "OFF",
      "OPS": "OPS",
      "P": "P",
      "PAS": "PAS",
      "PASS ATT": "PASS ATT",
      "PASS COMP": "PASS COMP",
      "PASS RTG": "PASS RTG",
      "PASS TD": "PASS TD",
      "PASS YDS": "PASS YDS",
      "PASS YDS/ATT": "PASS YDS/ATT",
      "PASS RZ ATT": "PASS RZ ATT",
      "PASS RZ COMPL": "PASS RZ COMPL",
      "PASS RZ TD": "PASS RZ TD",
      "PCRM": "PCRM",
      "PIM": "PUN",
      "PLAYS": "PLAYS",
      "POS": "POS",
      "POS%": "POS%",
      "PP%": "PP%",
      "PPG": "PPG",
      "PPP": "PPP",
      "PS": "PS",
      "PTS": "PTS",
      "R": "R",
      "RBI": "RBI",
      "REB": "REB",
      "REC": "REC",
      "REC TGT": "REC TGT",
      "REC TD": "REC TD",
      "REC YDS": "REC YDS",
      "REC YDS/REC": "REC YDS/REC",
      "REC 100+ YDS": "REC 100+ YDS",
      "REC RZ TGT": "REC RZ TGT",
      "REC RZ REC": "REC RZ REC",
      "REC RZ TD": "REC RZ TD",
      "RED": "CR",
      "RM": "RM",
      "RUSH ATT": "RUSH ATT",
      "RUSH LONG": "RUSH LONG",
      "RUSH TD": "RUSH TD",
      "RUSH YDS": "RUSH YDS",
      "RUSH YDS/ATT": "RUSH YDS/ATT",
      "RUSH 100+ YDS": "RUSH 100+ YDS",
      "RUSH RZ ATT": "RUSH RZ ATT",
      "RUSH RZ TD": "RUSH RZ TD",
      "RZ%": "RZ%",
      "S": "S",
      "S%": "S%",
      "SA": "SA",
      "SAT": "SAT",
      "SAV": "SAV",
      "SAVES": "SAVES",
      "SHG": "SHG",
      "SH%": "SH%",
      "SHO": "SHO",
      "SHP": "SHP",
      "SHUTOUTS": "SHUTOUTS",
      "SK": "SK",
      "SLG": "SLG",
      "SO": "SO",
      "SOG": "SOG",
      "SOT": "TC",
      "STL": "STL",
      "SV": "SV",
      "SV%": "SV%",
      "T": "N",
      "TA": "TA",
      "TB": "TB",
      "TCK": "TCK",
      "TD": "TD",
      "TO": "TO",
      "TOI": "TOI",
      "TRB": "REB",
      "TS%": "TS%",
      "USAGE %": "USAGE %",
      "W": "V",
      "WHIP": "WHIP",
      "WINS": "V",
      "XPA": "XPA",
      "XPM": "XPM",
      "XP%": "XP%",
      "YDS": "YDS",
      "YEL": "CJ",
      "FG (0-19)": "FG (0-19)",
      "FG (20-29)": "FG (20-29)",
      "FG (30-39)": "FG (30-39)",
      "FG (40-49)": "FG (40-49)",
      "FG (50+)": "FG (50+)",
      "300+ YDS": "300+ YDS",
    },
    sportStatHeaders: {
      "soccer": {
        "team": {
          "Running performance (per match)": "Performance de course (par match)",
          "Distance covered": "Distance parcourue",
          "Number of sprints": "Nombre de sprints",
          "Attacking": "Attaquer",
          "Goals per game": "Buts par match",
          "Penalty goals": "Buts sur pénalty",
          "Free kick goals": "Buts du coup-franc",
          "Goals from inside the box": "Buts dans la surface de réparation",
          "Goals from outside the box": "Buts à l'extérieur de la surface de réparation",
          "Left-footed goals": "Buts du pied gauche",
          "Right-footed goals": "Buts du pied droit",
          "Headed goals": "Buts de la tête",
          "Big chances per game": "Grosses occasions par match",
          "Big chances missed per game": "Grosses occasions ratées par match",
          "Total shots per game": "Total des tirs par match",
          "Shots on target per game": "Tirs cadrés par match",
          "Shots off target per game": "Tirs non cadrés par match",
          "Blocked shots per game": "Tirs bloqués par match",
          "Succ. dribbles per game": "Dribbles réussis par match",
          "Corners per game": "Corners par match",
          "Free kicks per game": "Coups francs par match",
          "Hit woodwork": "Frappe sur le poteau",
          "Counter attacks": "Contre-attaques",
          "Passes": "Passes",
          "Ball possession": "Possession",
          "Accurate passes": "Passes précises",
          "Acc. own half": "Précision dans son camp",
          "Acc. opposition half": "Précision dans le camp adverse",
          "Acc. long balls": "Précision longues passes",
          "Acc. crosses": "Bons centres",
          "Defending": "Défense",
          "Clean sheets": "Cage inviolée",
          "Goals conceded per game": "Buts encaissés par match",
          "Tackles per game": "Tacles par match",
          "Interceptions per game": "Interceptions par match",
          "Clearances per game": "Dégagements par match",
          "Saves per game": "Arrêts par match",
          "Balls recovered per game": "Ballons récupérés par match",
          "Errors leading to shot": "Erreurs menant à un tir",
          "Errors leading to goal": "Erreurs provoquant un but",
          "Penalties committed": "Penalties commis",
          "Penalty goals conceded": "Buts sur penalty concédés",
          "Clearance off line": "Dégagement de la ligne de but",
          "Last man tackle": "Dernier homme attaquer",
          "Other": "Autre",
          "Duels won per game": "Duels remportés par match",
          "Ground duels won": "Duels au sol remportés",
          "Aerial duels won": "Duels aériens remportés",
          "Possession lost per game": "Perte de balle par match",
          "Throw-ins per game": "Touches par match",
          "Goal kicks per game": "Coup de pied de but par match",
          "Offsides per game": "Hors-jeux par match",
          "Fouls per game": "Fautes par match",
          "Yellow cards per game": "Cartons jaunes par match",
          "Red cards": "Cartons rouges"
        },
        "player": {
          "Matches": "Matchs",
          "Appearances": "Apparitions",
          "Started": "Débuté",
          "Minutes per game": "Minutes par match",
          "Total minutes played": "Total des minutes jouées",
          "Team of the week": "L'équipe type de la journée",
          "Running performance (per 90)": "Performance de course (par 90)",
          "Top speed": "Vitesse maximale",
          "Goals": "Buts",
          "Expected goals (xG)": "Buts attendus (xG)",
          "Scoring frequency (in minutes)": "Fréquence de but (en minutes)",
          "Total shots": "Total des tirs",
          "Shots on target per game": "Shots on target per game",
          "Big chances missed": "Grosses occasions manquées",
          "Goal conversion": "Taux de conversion",
          "Penalty conversion": "Penalty réussi",
          "Free kick conversion": "Buts sur coups-francs",
          "Penalty won": "Penalty reussi",
          "Passing": "Passes",
          "Assists": "Passes décisives",
          "Expected assists (xA)": "Passe décisive attendus (xA)",
          "Touches": "Touches",
          "Big chances created": "Grosses occasions créées",
          "Key passes": "Passes clés",
          "Long balls (accurate)": "Passes longues (réussies)",
          "Accurate chip passes": "Passes lobées précises",
          "Interceptions": "Interceptions",
          "Possession won (final third)": "Possession gagnée (tiers offensif)",
          "Dribbled past per game": "Dribblé par match",
          "Other (per game)": "Autre (par match)",
          "Succ. dribbles": "Dribbles réussis",
          "Total duels won": "Total de duels remportés",
          "Possession lost": "Perte de balle",
          "Was fouled": "Fautes subies",
          "Offsides": "Hors-jeux",
          "Cards": "Cartons",
          "Yellow": "Jaune",
          "Red (2 yellows)": "Rouge (2 jaunes)",
          "Red": "Rouge"
        }
      },
      "hockey": {
        "team": {
          "Game overview": "Aperçu du match",
          "Shots on goal": "Tirs cadrés",
          "Penalties": "Pénalités",
          "Penalty minutes": "Minutes de pénalité",
          "Hits": "Plaquages",
          "Blocked shots": "Tirs bloqués",
          "Takeaways": "Interceptions",
          "Giveaways": "Revirements",
          "Empty net goals": "Buts en cage vide",
          "Power play %": "Supériorité numérique %",
          "Faceoffs won": "Mises en jeu gagnées",
          "Game Shotmap": "Tableau de tir du match",
          "Select shot type in shotmap": "Select shot type in shotmap",
          "Special teams": "Équipes spéciales",
          "Power play shot %": "Tirs en supériorité numérique %",
          "Shorthanded shot %": "Tirs en infériorité numérique %",
          "Even strength shot %": "Arrêts à égalité numérique %",
          "Power play faceoffs": "Mises en jeu en supériorité numérique",
          "Shorthanded faceoffs": "Engagements en infériorité numérique",
          "Even strength faceoffs": "Engagements à égalité numérique",
          "5v4 conversion": "Conversion 5v4",
          "Shots": "Tirs",
          "Wrist": "Poignet",
          "Slap": "Slap",
          "Backhand": "Revers",
          "Tip": "Déviation",
          "Snap": "Snap",
          "Advanced stats": "Statistiques avancées",
          "Corsi %": "Corsi %",
          "Fenwick %": "Fenwick %",
          "Average shot distance": "Distance moyenne des tirs"
        },
        "player": {
          "Overall": "Général",
          "Games played": "Matches joués",
          "Average time on ice": "Temps moyen sur la glace",
          "Goals": "Buts",
          "Assists": "Passes décisives",
          "Points": "Points",
          "Plus/minus": "Plus/minus",
          "Shots on goal": "Tirs cadrés",
          "Shooting percentage": "Pourcentage au tir",
          "Game winning goals": "But décisif",
          "Overtime goals": "But en prolongation",
          "Defensive": "Défensif",
          "Penalty minutes": "Minutes de pénalité",
          "Blocked shots": "Tirs bloqués",
          "Hits": "Charges",
          "Power play": "Supériorité numérique",
          "Powerplay average time on ice": "Temps moyen sur glace en supériorité numérique",
          "Power play goals": "Buts en supériorité numérique",
          "Power play assists": "Passes décisives en sup. numérique",
          "Power play points": "Points en supériorité numérique",
          "Shorthanded": "Infériorité numérique",
          "Shorthanded average time on ice": "Temps moyen sur glace en infériorité numérique",
          "Shorthanded goals": "Buts en infériorité numérique",
          "Shorthanded assists": "Passes décisives en inf. numérique",
          "Shorthanded points": "Points en infériorité numérique",
          "Shorthanded shots": "Tirs en infériorité numérique",
          "Even-strength": "Égalité numérique",
          "Even strength average time on ice": "Temps moyen sur glace à égalité numérique",
          "Faceoff": "Mise en jeu",
          "Faceoffs taken": "Mises en jeu prises à l'adversaire",
          "Faceoffs won": "Mises en jeu gagnées",
          "Faceoff win percentage": "Pourcentage de mises en jeu gagnées"
        }
      },
      "baseball": {
        "AB": "A la batte",
        "R": "Points marqués",
        "H": "Coups sûrs",
        "RBI": "Points produits",
        "HR": "Coups de circuit",
        "BB": "Buts sur balles",
        "K": "Retraits sur prises",
        "AVG": "Moyenne à la batte",
        "OBP": "Moyenne de présence sur les buts",
        "SLG": "Moyenne de puissance",
        "OPS": "Présence plus puissance",
        "IP": "Manches lancées",
        "ERA": "Moyenne de points mérités",
        "H_ALLOWED": "Coup sûrs accordés",
        "R_ALLOWED": "Manches accordées",
        "ER": "Points mérités",
        "BB_ALLOWED": "Buts sur balles accordés",
        "HR_ALLOWED": "Coups de circuit accordés",
        "NP": "Nombre de tirs",
        "STR": "Lancers effectués",
        "WHIP": "Coups sûr et buts sur balles/manches",
        "PO": "Retraits sur des prises",
        "A": "Passes décisives",
        "E": "Fautes",
        "DP": "Doubles jeux",
        "CS": "Tentative de Vol",
        "SB": "Buts volés accordés"
      },
      "basketball": {
        "team": {
          "Free throws": "Lancers-francs",
          "2 pointers": "2 points",
          "3 pointers": "3 points",
          "Field goals": "Paniers",
          "Rebounds": "Rebonds",
          "Defensive rebounds": "Rebonds défensifs",
          "Offensive rebounds": "Rebonds offensifs",
          "Assists": "Passes décisives",
          "Turnovers": "Pertes de balles",
          "Steals": "Interceptions",
          "Blocks": "Contres",
          "Fouls": "Fautes",
          "Max points in a row": "Max de points d'affilée",
          "Time spent in lead": "Temps de domination",
          "Biggest lead": "Plus gros écart"
        },
        "player": {
          "MIN": "Minutes jouées",
          "PTS": "Points",
          "REB": "Rebonds",
          "AST": "Passes décisives",
          "STL": "Interceptions",
          "BLK": "Contres",
          "PF": "Fautes personnelles",
          "TOV": "Pertes de balles",
          "OREB": "Rebonds offensifs",
          "DREB": "Rebonds défensifs",
          "FG": "Paniers",
          "FG%": "% de tirs réussis",
          "FT": "Lancers-francs",
          "FT%": "% de coups francs",
          "3P": "3 points",
          "3P%": "Pourcentage à 3 points",
          "+/-": "Plus/Minus",
          "PIR": "L'indice de performance"
        }
      },
      "americanFootball": {
        "team": {
          "Offense": "Offensif",
          "TD": "Essais",
          "FG": "Paniers",
          "NET YDS": "Distance totale",
          "TO": "Pertes de balles",
          "RZ%": "Efficacité sur la zone rouge",
          "1D": "Première tentative",
          "3D%": "Efficacité de la troisième tentative",
          "Passing": "Passes",
          "PASS YDS": "Yards nets de passes",
          "PASS TD": "TD à la passe",
          "INT THROWN": "Interceptions lancées",
          "PASS YDS/ATT": "Moy cde yards / passe tentée",
          "PASS RZ ATT": "Passes tentées zone rouge",
          "Rushing": "Courses",
          "RUSH ATT": "Courses tentées",
          "RUSH YDS": "Distances parcourus",
          "RUSH YDS/ATT": "Moy de yards / course",
          "Rushing 1st downs": "1res tentatives obtenues à la course",
          "RUSH RZ ATT": "Courses tentées zone rouge",
          "Other": "Autre",
          "FUML": "Échappés perdus"
        },
        "player": {
          "PASS COMP": "Balles captées",
          "PASS ATT": "Tentatives",
          "PASS YDS": "Yards à la passe",
          "PASS TD": "TD à la passe",
          "INT": "Passes interceptées",
          "PASS YDS/ATT": "Yards par passe",
          "PASS RTG": "Évaluation du quarterback",
          "RUSH ATT": "Courses tentées",
          "RUSH YDS": "Distances parcourus",
          "RUSH TD": "TD à la course",
          "RUSH YDS/ATT": "Yards par course",
          "RUSH LONG": "Course la plus longue",
          "REC TGT": "Nombre de passes lancées au receveur",
          "REC": "Réceptions",
          "REC YDS": "Yards en réception",
          "REC TD": "TD en réception",
          "REC YDS/REC": "Yards par réception de passe",
          "TCK": "Plaquages cumulés",
          "SK": "Sacks effectués",
          "FUML": "Échappés perdus",
          "FGM": "Field goal réussis",
          "XPM": "Extra point réussis",
          "PTS": "Total des points"
        }
      },
      "rugby": {
        "team": {
          "Ball possession": "Possession",
          "Passes": "Passes",
          "Tries": "Essais",
          "Try assists": "Assistances essayées",
          "Conversions": "Transformations",
          "Carries": "Courses",
          "Clean breaks": "Franchissements",
          "Penalty goals": "Buts sur pénalty",
          "Drop goals": "Abandonner les objectifs",
          "Scrums": "Mêlées",
          "Lineouts": "Alignements",
          "Turnovers": "Pertes de balles",
          "Turnovers won": "Chiffre d'affaires gagné",
          "Meters run": "Les compteurs courent",
          "Offloads": "Déchargements",
          "Tackles": "Tacles",
          "Tackles missed": "Plaquages manqués",
          "Penalties conceded": "Pénalités concédées",
          "Red cards": "Cartons rouges",
          "Yellow cards": "Cartons jaunes"
        },
        "player": {
          "PTS": "Points",
          "TRY": "Essais",
          "TKL": "Tacles",
          "PG": "Buts sur pénalty",
          "PAS": "Passes",
          "CAR": "Courses",
          "CB": "Franchissements",
          "DG": "Abandonner les objectifs",
          "MR": "Les compteurs courent",
          "OFF": "Déchargements",
          "TM": "Plaquages manqués",
          "TA": "Assistances essayées",
          "TW": "Chiffre d'affaires gagné"
        }
      }
    },
    positions: {
      goalies: "Gardiens",
      skaters: "Patineurs",
      pitchers: "Lanceurs",
      hitters: "Frappeurs",
      forwards: "Attaquants",
      midfielders: "Milieux",
      defenders: "Défenseurs",
      outfielders: "Voltigeurs",
      players: "Joueurs",
    },
    filters: {
      titles: {
        lineType: "Type de ligne",
        game: "Match",
        outcome: "Plus/Moins",
        betType: "Type de pari",
        trendType: "Type de tendance",
        signals: "Signaux",
        season: "Saison",
        team: "Équipe",
        minOdds: "Cote min.",
        timeframe: "Période",
      },
      plurals: {
        lineType: "Types de ligne",
        game: "Matchs",
        outcome: "Résultats",
        betType: "Types de pari",
        trendType: "Types de tendance",
        signals: "Signaux",
        season: "Saisons",
        team: "Équipes",
      },
      options: {
        game: {
          all: "Tous les matchs",
          byGame: "Par match",
        },
        team: {
          all: "Toutes les équipes",
        },
        lineType: {
          main: "Lignes principales",
          alternate: "Lignes alternatives",
        },
        outcome: {
          all: "Plus+Moins",
          over: "Plus",
          under: "Moins",
          yes: "Oui",
          no: "Non",
          cover: "Couvrir",
        },
        betType: {
          all: "Tous les types de pari",
        },
        minOdds: {
          all: "Toutes les cotes",
        },
        timeframe: {
          season: "Saison",
          playoffs: "Séries",
          headToHead: "Face-à-face",
          last5: "5 derniers",
          last10: "10 derniers",
          last20: "20 derniers",
          last30: "30 derniers",
        },
        splits: {
          all: "Domicile+Extérieur",
          home: "Domicile",
          away: "Extérieur",
        },
        trendType: {
          player: "Joueur",
          team: "Équipe",
        },
        qualifier: {
          averageStats: "Par match",
          cumulativeStats: "Total",
        },
        signals: {
          allSignals: "Tous les signaux",
          recentForm: "Forme récente",
          headToHead: "Face-à-face",
          homeAwaySplits: "Domicile/extérieur",
          opponentRank: "Classement adverse",
          injuryImpact: "Impact des blessures",
          starter: "Titulaire",
          weather: "Météo",
          startingPitcher: "Lanceur partant",
        },
      },
    },
    empty: {
      checkBackLater: "Veuillez revenir plus tard.",
      pendingOdds: {
        title: "Cotes en attente",
      },
    },
  },
  betTypes: {
    ANYTIME_GOAL_SCORER: "Buts",
    ANYTIME_TOUCHDOWN: "TD à tout moment",
    ANYTIME_TOUCHDOWN_1Q: "TD à tout moment 1Q",
    ANYTIME_TRY_SCORER: "Marqueur d'essai à tout moment",
    ASSISTS: "Passes décisives",
    ASSISTS_1Q: "Passes décisives 1Q",
    ASSISTS_PLUS_REBOUNDS: "REB+AST",
    BLOCKED_SHOTS: "Tirs bloqués",
    BLOCKS: "Contres",
    BOTH_TEAMS_TO_SCORE: "Les deux équipes marquent",
    CARDS: "Cartons",
    CORNERS: "Corners d'équipe",
    DISPOSALS: "Disposals",
    DOUBLE_CHANCE: "Double chance",
    DOUBLE_DOUBLE: "Double-double",
    EXTRA_POINTS_MADE: "XP réussis",
    FIELD_GOALS_MADE: "FG réussis",
    GAME_TOTAL: "Total du match",
    GAME_TOTAL_1H: "Total du match 1re demie",
    GAME_TOTAL_1Q: "Total du match 1Q",
    GAME_TOTAL_2H: "Total du match 2e demie",
    GAME_TOTAL_CARDS: "Total de cartons du match",
    GAME_TOTAL_FIRST_5_INNINGS: "Total du match 5 premières manches",
    GOAL_OR_ASSIST: "But ou passe décisive",
    GOALS: "Buts",
    GOALS_ALLOWED: "Buts contre",
    HITTER_DOUBLES: "Doubles",
    HITTER_HITS: "Coups sûrs",
    HITTER_HITS_PLUS_RUNS_PLUS_RUNS_BATTED_IN: "H+R+RBI",
    HITTER_HOME_RUNS: "Circuits",
    HITTER_RUNS: "Points marqués",
    HITTER_RUNS_BATTED_IN: "Points produits",
    HITTER_SINGLES: "Simples",
    HITTER_STOLEN_BASES: "Buts volés",
    HITTER_TOTAL_BASES: "Total de buts",
    HITTER_TRIPLES: "Triples",
    INTERCEPTIONS: "Interceptions",
    KICKING_POINTS: "Points au pied",
    MARKS: "Marques",
    MONEY_LINE: "Vainqueur",
    MONEY_LINE_1H: "Vainqueur 1re demie",
    MONEY_LINE_1Q: "Vainqueur 1Q",
    MONEY_LINE_2H: "Vainqueur 2e demie",
    MONEY_LINE_FIRST_5_INNINGS: "Vainqueur 5 premières manches",
    PASSING_ATTEMPTS: "Tent. passes",
    PASSING_COMPLETIONS: "Passes compl.",
    PASSING_PLUS_RUSHING_YARDS: "Verges passe + course",
    PASSING_PLUS_RUSHING_YARDS_1Q: "Verges passe + course 1Q",
    PASSING_TOUCHDOWNS: "TD par la passe",
    PASSING_YARDS: "Verges par la passe",
    PASSING_YARDS_1Q: "Verges par la passe 1Q",
    PITCHER_EARNED_RUNS: "Points mérités",
    PITCHER_HITS_ALLOWED: "Coups sûrs accordés",
    PITCHER_OUTS: "Retraits du lanceur",
    PITCHER_STRIKEOUTS: "Retraits sur prises",
    PITCHER_WALKS_ALLOWED: "Buts sur balles accordés",
    POINTS: "Points",
    POINTS_1Q: "Points 1Q",
    POINTS_PLUS_ASSISTS: "PTS+AST",
    POINTS_PLUS_ASSISTS_PLUS_REBOUNDS: "PTS+AST+REB",
    POINTS_PLUS_REBOUNDS: "PTS+REB",
    POWERPLAY_POINTS: "Points en avantage",
    REBOUNDS: "Rebonds",
    REBOUNDS_1Q: "Rebonds 1Q",
    RECEIVING_YARDS: "Verges sur réception",
    RECEIVING_YARDS_1Q: "Verges sur réception 1Q",
    RECEPTIONS: "Réceptions",
    RUN_FIRST_INNING: "Point en 1re manche",
    RUSHING_ATTEMPTS: "Courses tentées",
    RUSHING_PLUS_RECEIVING_YARDS: "Verges course + réception",
    RUSHING_PLUS_RECEIVING_YARDS_1Q: "Verges course + réception 1Q",
    RUSHING_YARDS: "Verges au sol",
    RUSHING_YARDS_1Q: "Verges au sol 1Q",
    SAVES: "Arrêts",
    SHOTS: "Tirs",
    SHOTS_ON_GOAL: "Tirs au but",
    SHOTS_ON_TARGET: "Tirs cadrés",
    player: {
      SHOTS_ON_TARGET: "Tirs cadrés",
    },
    team: {
      SHOTS_ON_TARGET: "Tirs cadrés de l'équipe",
    },
    SHUTOUT: "Blanchissage",
    SPREAD: "Écart",
    SPREAD_1H: "Écart 1re demie",
    SPREAD_1Q: "Écart 1Q",
    SPREAD_2H: "Écart 2e demie",
    SPREAD_FIRST_5_INNINGS: "Écart 5 premières manches",
    STEALS: "Interceptions",
    STEALS_PLUS_BLOCKS: "STL+BLK",
    TACKLES: "Plaquages",
    TEAM_TOTAL: "Total d'équipe",
    TEAM_TOTAL_1H: "Total d'équipe 1re demie",
    TEAM_TOTAL_1Q: "Total d'équipe 1Q",
    TEAM_TOTAL_2H: "Total d'équipe 2e demie",
    TEAM_TOTAL_CARDS: "Total de cartons d'équipe",
    THREE_POINTS_MADE: "3 pts réussis",
    TRIES: "Essais",
    TRIPLE_DOUBLE: "Triple-double",
    TURNOVERS: "Revirements",
    WIN_TO_NIL: "Victoire sans encaisser",
  },
};
